import React, { useMemo, useState } from "react";

import ModalContainer from "components/UI/_TODO/WorkOrMaterialsModals/components/ModalContainer/ModalContainer";

import { useBuildingPermissionsContext } from "../../contexts/BuildingPermissionsContext";
import ExpenditureAllFactsTab from "./tabs/ExpenditureAllFactsTab/ExpenditureAllFactsTab";
import ExpenditureAllPlansTab from "./tabs/ExpenditureAllPlansTab/ExpenditureAllPlansTab";
import TabBarNotLinks, { ITab } from "shared/ui/controls/TabBar/TabBarNotLinks";
import { IBaseModalProps } from "shared/ui/modal/SliderModal/SliderModal";

import { IExpenditure } from "types/interfaces/Expenditure";

import styles from "./ExpenditureAllIntervalsModal.module.scss";

interface IProps extends IBaseModalProps {
  expenditure: IExpenditure;
  buildingId: any;
  sectionName: any;
  date_start: string;
  date_end: string;
  canDeleteFiles: boolean;
  loadProduct: () => void;
  sectionId: number;
  defaultOpenedIntervalId?: string | null;
  modalTitle?: React.ReactNode;
  hideWorkNameInList?: boolean;
  defaultTab?: string;
}

const ExpenditureAllIntervalsModal = ({
  expenditure,
  buildingId,
  sectionName,
  date_start,
  date_end,

  canDeleteFiles,
  loadProduct,
  sectionId,
  defaultOpenedIntervalId = null,
  modalTitle,
  hideWorkNameInList,
  defaultTab,
  ...modalProps
}: IProps) => {
  const { canViewPlan, canViewProgress } = useBuildingPermissionsContext();
  const tabs = useMemo(() => {
    return getTabs(canViewProgress, canViewPlan);
  }, [canViewProgress, canViewPlan]);
  const [tab, setTab] = useState(defaultTab || tabs[0]?.id);

  if (!tabs.length) {
    return null;
  }

  return (
    <ModalContainer name={expenditure.name} {...modalProps}>
      <div className={styles.content}>
        <div className={styles.tabs}>
          <TabBarNotLinks tabs={tabs} activeId={tab} onClick={setTab} isOnlyTabsView />
        </div>
        {tab === "plan" && (
          <ExpenditureAllPlansTab
            {...modalProps}
            expidentureId={expenditure.id}
            expidentureObj={expenditure}
            objectId={buildingId}
            sectionName={sectionName}
            date_start={date_start}
            date_end={date_end}
            canDeleteFiles={canDeleteFiles}
            loadProduct={loadProduct}
            sectionId={sectionId}
            hideWorkNameInList={hideWorkNameInList}
          />
        )}
        {tab === "fact" && (
          <ExpenditureAllFactsTab
            {...modalProps}
            expidentureId={expenditure.id}
            expidentureObj={expenditure}
            objectId={buildingId}
            sectionName={sectionName}
            date_start={date_start}
            date_end={date_end}
            canDeleteFiles={canDeleteFiles}
            loadProduct={loadProduct}
            sectionId={sectionId}
          />
        )}
      </div>
    </ModalContainer>
  );
};

export default ExpenditureAllIntervalsModal;

const getTabs = (canViewProgress: boolean, canViewPlan: boolean) =>
  [
    canViewPlan ? { id: "plan", text: "План" } : null, //
    canViewProgress ? { id: "fact", text: "Факт" } : null,
  ].filter(Boolean) as ITab[];
